<template>
  <div class="smart-detection-over-view">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="smart-detection-environmental-monitoring-line">
      <div class="smart-detection-environmental-monitoring-line-item" v-for="item in environmentMonitorList">
        <div class="smart-detection-environmental-monitoring-line-item-top">
          <div>{{item.powerRoomName}}</div>
          <div class="smart-detection-environmental-monitoring-line-item-top-video" @click="preview(item)" v-if="item.videoDeviceCode">
            <i class="el-icon-damai-ic_Indoormonitoring"></i>
            <div>视频</div>
          </div>
        </div>
        <div class="smart-detection-environmental-monitoring-line-item-main">
          <div class="smart-detection-environmental-monitoring-line-item-main-load-rate" v-if="item.status === 0">正常</div>
          <div class="smart-detection-environmental-monitoring-line-item-main-load-rate-abnormal" v-else>异常</div>
          <div class="smart-detection-environmental-monitoring-line-item-main-environment">
            <div class="smart-detection-environmental-monitoring-line-item-main-environment-line">
              <i class="iconfont el-icon-damai-shineiwendu"></i>
              <div>温度 {{item.temperature}}℃</div>
            </div>
            <div class="smart-detection-environmental-monitoring-line-item-main-environment-line">
              <i class="iconfont el-icon-damai-shineishidu"></i>
              <div>湿度 {{item.humidity}}%</div>
            </div>
            <div class="smart-detection-environmental-monitoring-line-item-main-environment-line">
              <i class="iconfont el-icon-damai-shineishuijin"></i>
              <div>水浸 <span v-if="item.waterOut === '0'" style="color: #3B7CFF">正常</span><span style="color: #FD6450" v-else>异常</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :title="previewDeviceName" :visible.sync="dialogVisible" width="600px">
      <div class="video-page-right-main-box">
        <HlsVideo v-if="previewProtocolType === '大华云睿' && videoUrl" class="video-page-right-main-box-choose DHVideoPlayer" />
        <HKPlayer v-if="previewProtocolType === '海康云眸' && hkVideoPlayerLink" :hkVideoPlayerLink="hkVideoPlayerLink" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import {api} from "../../api/SmartDetection";
import TableMain from "../../../components/Table/TableMain";
import {nSuccess} from "../../../utils/notice";
import {errorHandler} from "../../../utils/errorHandler";
import OverViewTopLine from "../../../components/OverView/OverViewTopLine";
import DHPlayer from "../../../components/DHPlayer/DHPlayer";
import HKPlayer from "../../../components/HKPlayer/HKPlayer";
import HlsVideo from "../../../components/HlsVideo/HlsVideo";
export default {
  name: 'SmartDetectionOverView',
  components: {HlsVideo, HKPlayer, DHPlayer, OverViewTopLine, TableMain, Breadcrumb},
  data () {
    return {
      breadcrumb: [{
        value: '配电监测',
        name: 'smart-detection-over-view'
      }, {
        value: '环境监测'
      }],
      environmentMonitorList: [],

      dialogVisible: false,
      previewDeviceName: '',
      previewDeviceCode: '',
      previewProtocolType: '大华云睿',
      dHPreviewToken: '',
      hkVideoPlayerLink: '',
      videoUrl: ''
    }
  },
  created() {
    this.getEnvironmentMonitorList()
  },
  methods: {
    // 查询列表
    getEnvironmentMonitorList () {
      this.$axios.post(api.getEnvironmentMonitorList, {})
        .then(res => {
          let data = res.data.data
          this.environmentMonitorList = data
        })
        .catch(errorHandler('查询信息失败'))
    },

    // 预览
    preview (row) {
      let deviceName = row.videoDeviceName
      let deviceCode = row.videoDeviceCode
      let protocolType = row.videoDeviceProtocolType
      this.previewDeviceName = deviceName
      this.previewDeviceCode = deviceCode
      this.previewProtocolType = protocolType
      let url = ''
      if (protocolType === '大华云睿') {
        url = `${api.getVideoHlsStream}`
      } else {
        url = `${api.preview}`
      }
      this.$axios.post(url, {
        deviceCode: deviceCode
      })
        .then(res => {
          let data = res.data.data
          if (data) {
            if (protocolType === '大华云睿') {
              this.dialogVisible = true
              this.$nextTick(() => {
                this.videoUrl = data.hls
              })
            } else if (protocolType === '海康云眸') {
              this.isPlayHKVideo = true
              let token = data
              let channelNum = row.deviceId
              this.hkVideoPlayerLink = `https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/${deviceCode}/${channelNum || '1'}.live&autoplay=1&accessToken=${token}`
              setTimeout(() => {
                this.isPlayHKVideo = false
              }, 120000)
              // this.play(token, deviceCode)
            }
          }
        })
        .catch(errorHandler('预览失败'))
    },
  },
}
</script>

<style scoped lang="less">
.smart-detection-over-view {
  .smart-detection-environmental-monitoring-line {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    margin: 20px 0;
    .smart-detection-environmental-monitoring-line-item {
      width: 650px;
      height: 282px;
      background: #FFFFFF;
      border-radius: 7px;
      margin: 0 0 20px;
      padding: 0;
      border: 1px solid rgb(220, 223, 230);
      box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 4px 0px, rgba(0, 0, 0, 0.04) 0px 0px 6px 0px;
      .smart-detection-environmental-monitoring-line-item-top {
        height: 41px;
        line-height: 41px;
        font-size: 18px;
        font-weight: bolder;
        background: #F2F8FF;
        border-radius: 7px 7px 0px 0px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .smart-detection-environmental-monitoring-line-item-top-video {
          color: #0062FF;
          cursor: pointer;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .el-icon-damai-ic_Indoormonitoring {
            font-size: 24px;
            margin-right: 5px;
          }
        }
      }
      .smart-detection-environmental-monitoring-line-item-main {
        margin-top: 20px;
        padding: 0 100px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .smart-detection-environmental-monitoring-line-item-main-load-rate {
          width: 120px;
          height: 120px;
          line-height: 80px;
          border-radius: 50%;
          border: 20px solid #3B7CFF;
        }
        .smart-detection-environmental-monitoring-line-item-main-load-rate-abnormal {
          width: 120px;
          height: 120px;
          line-height: 80px;
          border-radius: 50%;
          border: 20px solid #FD6450;
        }
        .smart-detection-environmental-monitoring-line-item-main-environment {
          width: 171px;
          height: 180px;
          font-size: 14px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: column;
          .smart-detection-environmental-monitoring-line-item-main-environment-line {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 171px;
            height: 47px;
            line-height: 47px;
            background: #F7FAFF;
            border-radius: 12px;
            i {
              color: #4C92FE;
              font-size: 42px;
              background: #E6F0FF;
              border-radius: 12px;
            }
            div {
              flex: 1;
              font-size: 14px;
            }
          }
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/view/SmartDetection/SmartDetectionEnvironmentalMonitoring/SmartDetectionEnvironmentalMonitoring.vue